/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

// Redux Store
import { ControlTable } from "../../components/Table";
import { getParams } from "../../utils/params";
import { each, get, isArray } from "lodash";
import { isEmpty } from "lodash-es";
import systemAlert from "../../utils/systemAlert";
import {
  COMPANY_TYPE, COMPANY_SEP
  // ,COMPANY_STATE
} from "../../constants/COMPANY";
import { toast } from "../../utils/toast";
import useForm from "../../hooks/useForm";
import { transformComNum } from "../../utils/validator/comNum";
import { transformMobile } from "../../utils/validator/mobile";
import Filters from "../Filters";
import { getStoreCompanies } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { getRequestPartnerCompanies, requestPartnerApproved, requestPartnerDenied } from "../../apis/partner/partner";

import Modal, { ModalHeader } from "../Modal";
import Managers from "../Manager/Mangers";
import Pertner from "./Partner";
import { isAdmin } from "../../utils/auth";
import MangerCompany from "../Manager/ManagerCompay";
import { getCareCompany } from "../../apis/admin/companies";


const PartnerRequestCompanies = () => {

  const dispatch = useDispatch();
  const [managerViewCompany, setManagerViewCompany] = useState(null);
  const [selectedPartnerCompnay, setSelectedPartnerCompnay] = useState(null);
  const [careCompany, setCareCompany] = useState(null);
  const [fields, setFields] = useState([]);

  const [tableButtons, setTableButtons] = useState([]);

  const { company } = useSelector((store) => store.Profile);

  useEffect(() => {
    if (!isEmpty(company)) {
      setFields([
        { title: "회사타입", label: '-', key: "type", onTranslator: { list: COMPANY_TYPE } },
        { title: "회사명", label: '-', key: "name" },
        { title: "구분", label: '-', key: "sep", onTranslator: { list: COMPANY_SEP } },
        {
          title: "사업자번호", label: '-', key: "comNum", onValue: (value) => {
            return transformComNum(value);
          }
        },
        { title: "대표자명", label: '-', key: "ceoName" },
        // { title: "승인 상태", label: '-', key: "state", onTranslator: { list: COMPANY_STATE } },
        { title: "등록일자", label: '-', key: "createdTime", type: 'datetime' },
        { title: "요청세무사", label: '-', key: "taxCompanyCodeCompany.name" },
        { title: "최초접근세무사", label: '-', key: "throughTaxCompanyCodeCompany.name" },
        { title: "요청자명", label: '-', key: "userName" },
        {
          title: "요청자연락처", label: '-', key: "userMobile", onValue: (value) => {
            return transformMobile(value);
          }
        },
        ...(isAdmin() ? [{
          type: "button",
          size: "x-sm",
          color: "gray-line",
          label: "매니징 수정",
          onClick: ({ data }) => {
            setManagerViewCompany(data);
          },
        }] : []),
        {
          type: 'button',
          size: 'x-sm',
          color: 'green',
          label: '승인',
          disabled: (data) => {
            return !data.taxCompanyCode;
          },
          style: {
            width: '60px'
          },
          onClick: ({ data }) => {
            approveCompanies(data);
          }
        },

        {
          type: 'button',
          size: 'x-sm',
          color: 'red',
          label: '반려',
          disabled: (data) => {
            return !data.taxCompanyCode;
          },
          style: {
            width: '60px'
          },
          onClick: ({ data }) => {
            deniesCompanies(data);
          }
        },
      ]);
      setTableButtons([
        {
          label: "승인",
          action: () => {
            approveCompanies(selectedList);
          },
          disabled: isEmpty(selectedList),
        },
        {
          label: "반려",
          color: "red",
          action: () => {
            deniesCompanies(selectedList);
          },
          disabled: isEmpty(selectedList),
        },
      ]);
    }
  }, [company]);

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    reSubmit,
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      searchType: 'name',
      searchText: '',
      order: [
        {
          idx: "desc"
        },
      ],
      page: 0,
      limit: 10
    },
  );

  const approveCompanies = (companies) => {
    if (!isArray(companies)) companies = [companies];
    const message = (companies.length > 1) ?
      `${companies.length}건을 승인하시겠습니까?`
      : `"${companies[0].name}"을(를) 승인하시겠습니까?`;
    systemAlert(message, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {
            each(companies, ({ idx, taxCompanyCode, name }) => {
              if (taxCompanyCode) {
                requestPartnerApproved(idx)
                  .then(() => {
                    toast.success(`"${name}" 회사 등록 승인되었습니다.`);
                    submit();
                    !isAdmin() && getCareCompany(company.idx, company.type, idx).then(data => {
                      const _company = get(data, "data.company");
                      setCareCompany(_company);
                    });
                  })
                  .catch((err) => {
                    toast.error(`"${name}" 회사 등록 승인실패했습니다. : ${err}`);
                  })
                  .finally(() => {
                    dispatch(getStoreCompanies());
                  });
              } else {
                toast.error(`"${name}" 회사는 요청 세무사가 없습니다.`);
              }
            });
          }
        }
      ]
    });
  };

  const deniesCompanies = (companies) => {
    if (!isArray(companies)) companies = [companies];
    const message = (companies.length > 1) ?
      `${companies.length}건을 반려하시겠습니까?`
      : `"${companies[0].name}"을(를) 반려하시겠습니까?`;

    systemAlert(message, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '반려',
          onClick: () => {
            each(companies, ({ idx, taxCompanyCode, name }) => {

              if (taxCompanyCode) {
                requestPartnerDenied(idx)
                  .then(() => {
                    toast.success(`"${name}" 회사 등록 반려되었습니다.`);
                    submit();
                  })
                  .catch((err) => {
                    toast.error(`"${name}" 회사 등록 반려실패했습니다. : ${err}`);
                  })
                  .finally(() => { });
              } else {
                toast.error(`"${name}" 회사는 요청 세무사가 없습니다.`);
              }

            });
          }
        }
      ]
    });
  };

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  const submit = (param) => {
    getRequestPartnerCompanies({
      ...getParams(param),
      filter: 'allow'
    })
      .then((res) => {
        setTotal(get(res, "data.total"));
        setList(get(res, "data.companies"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
        setSelectedList([]);
      });
  };


  const [filters] = useState([
    {
      title: "타입",
      type: "select",
      key: "search.type",
      defaultValue: '',
      options: {
        list: [
          { label: "전체", value: '' },
          ...COMPANY_TYPE
        ]
      },
    },
    {
      title: "상호",
      key: "search.name",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "사업자번호",
      key: "search.comNum",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "대표이름",
      key: "search.ceoName",
      options: {
        placeholder: "검색어 입력",
      },
    },
  ]);


  return (
    <>

      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        title={'서비스 요청 대기중인 회사 목록'}
        fields={fields}
        list={list}
        isLoading={isLoading}
        buttons={tableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
      // isControl={false}
      />

      <Modal
        isOpen={!!managerViewCompany}
        close={() => {
          setManagerViewCompany(null);
          reSubmit();
        }}
      >
        {managerViewCompany && (
          <>
            <ModalHeader>{managerViewCompany.name} 매니저 관리</ModalHeader>
            <Managers targetCompany={managerViewCompany}></Managers>
          </>
        )}
      </Modal>
      <Modal
        isOpen={!!selectedPartnerCompnay}
        close={() => {
          setSelectedPartnerCompnay(null);
          reSubmit();
        }}
      >
        {selectedPartnerCompnay && (
          <>
            <Pertner partnerCompany={selectedPartnerCompnay} />
          </>
        )}
      </Modal>

      {!isEmpty(company) && !isEmpty(careCompany) && (
        <MangerCompany
          open={!!careCompany}
          setOpen={() => { setCareCompany(null); }}
          list={[company]}
          type={company.type}
          myCareCompany={careCompany}
          submit={reSubmit}
        />
      )}
    </>
  );
};

export default PartnerRequestCompanies;